import React, { useState } from 'react';
import CardProfile from '../../../components/Profile/Card/';

import ExperienceForm from '../../../components/Forms/Perfil/Experience';
import { Formik } from 'formik';
import { validationExperienceProfile } from '../../../utils/validations';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import AuthButton from '../../../components/Buttons/AuthButton';
import ButtonAction from '../../../components/Buttons/ButtonAction';
import OptionsButton from '../../../components/Buttons/OptionsButton';
import Counter from "../../../components/TextCounter/components/Counter";
import { connect } from 'react-redux';
import { experienceForm } from '../../../store/actions/UserAction'
import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import ReactQuill, { Toolbar } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { showLoading, hideLoading } from "../../../store/actions/LoadingActions";

//import TextCounter from '../../TextCounter';

import { makeStyles } from '@material-ui/styles';
import './experience.scss';

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
});


const Experience = ({ role, authClient, experienceForm, showLoading, hideLoading }) => {
  const [loadingFormData, setLoadingFormData] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'info'
  });
  const [dataExperience, setDataExperience] = useState()
  const [isValid, setIsValid] = useState()
  const [errorLenth, setErrorLenth] = useState(false);

  const handleSubmit = () => {

    showLoading()
    const arrayValues = Object.values(dataExperience)
    const boolValues = arrayValues.every(elem => elem)
    experienceForm(dataExperience, authClient.uid, boolValues).then(res => {
      setFeedbackMessage({
        open: true,
        message: 'Tus cambios se han guardado con éxito',
        variant: 'success'
      });
      hideLoading()
    })
      .catch(error => hideLoading())

  };

  const formValues = {
    experience: authClient.experience,
  };
  const classes = useStyles();

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };

  const handleChangeExperience = (value) => {

    value.length >= 2300 ? setErrorLenth(true) : setErrorLenth(false)
    if (value.length <= 2300) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }

    setDataExperience(value)
  }




  return (
    <div className='experience expertise'>
      <CardProfile
        title={role === 'lawFirm' ? 'Experiencia como despacho' : 'Experiencia'}
        subTitle='Descripción de experiencia en el ámbito profesional.'
        awardIcon
        status={authClient && authClient.awardPerfil.experience ? authClient.awardPerfil.experience : false}
      >
        <div className="contentQuill">
          <ReactQuill
            className="quillExperience"
            theme="snow"
            defaultValue={authClient.experience}
            onChange={handleChangeExperience} />
          {errorLenth && <p className="textError">Llegaste al límite de caracteres permitido</p>}
        </div>

        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          className="button_send_experience"
          disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </CardProfile>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};


const mapDispatchToProps = dispatch => ({
  experienceForm: (data, uid, boolValues) => dispatch(experienceForm(data, uid, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading())
})


const mapStateToProps = state => ({
  authClient: state.authClient,
});

export default connect(mapStateToProps, mapDispatchToProps)(Experience);
